import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../../../redux/configureStore';
import { IGetPartners } from '../interfaces';

function GetPartners(props: IGetPartners) {
  const faresFilterState = useSelector(
    (reducer: IReducer) => reducer.faresFilter
  );

  let array: any = [];

  if (faresFilterState.fare === 'slb' || faresFilterState.fare === 'tib') {
    return (
      <option key={1} value={1}>
        1 - Fidúcia SCM
      </option>
    );
  }
  array = props.partnerFilter.map((partner: any) => {
    return (
      <option key={partner.id} value={partner.id}>
        {partner.id} - {partner.razao_social}
      </option>
    );
  });

  array.sort((a: any, b: any) => {
    if (a.props.value > b.props.value) {
      return 1;
    }
    if (a.props.value < b.props.value) {
      return -1;
    }
    return 0;
  });

  return array;
}

export default GetPartners;
